// Commit layout once; animate the content reveal and displaced cards without
// changing grid rows on every animation frame.
export function animateExpander(header, update, onExpanded) {
  const root = header?.closest('.order-panel');
  const body = header?.nextElementSibling;
  const content = body?.firstElementChild;
  if (!root || !content || !body.classList.contains('collapse-card-container') ||
      matchMedia('(prefers-reduced-motion: reduce)').matches || !content.animate) {
    update();
    if (body?.getAttribute('role') === 'visible') onExpanded?.();
    return () => {};
  }
  const cards = [...root.querySelectorAll('.collapse-card-header, .collapse-card-container:not(.order-ticket)')];
  const before = cards.map(node => node.getBoundingClientRect().top);
  const closing = body.getAttribute('role') === 'visible';
  const height = content.getBoundingClientRect().height;
  const savedBody = body.style.cssText;
  const savedContent = content.style.cssText;
  update();
  const after = cards.map(node => node.getBoundingClientRect().top);
  // Measure the final layout and begin scrolling in this same frame, before
  // temporary FLIP transforms affect the section's bounding rectangle.
  if (!closing) onExpanded?.();
  if (closing) {
    body.style.setProperty('position', 'relative', 'important');
    body.style.setProperty('overflow', 'visible', 'important');
    body.style.setProperty('opacity', '1', 'important');
    content.style.setProperty('position', 'absolute', 'important');
    content.style.setProperty('inset', '0 0 auto', 'important');
    content.style.setProperty('height', `${height}px`, 'important');
    content.style.setProperty('width', '100%', 'important');
  }
  const options = { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' };
  const animations = cards.flatMap((node, index) => {
    const offset = before[index] - after[index];
    return Math.abs(offset) > 0.5 ? [node.animate([
      { transform: `translateY(${offset}px)` }, { transform: 'translateY(0)' },
    ], options)] : [];
  });
  const reveal = [{ clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)' }];
  animations.push(content.animate(closing ? [...reveal].reverse() : reveal, options));
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    body.style.cssText = savedBody;
    content.style.cssText = savedContent;
    animations.forEach(animation => animation.cancel());
  };
  Promise.all(animations.map(animation => animation.finished)).then(() => {
    if (finished) return;
    finish();
  }, finish);
  return finish;
}
